export default __webpack_public_path__ + "fk-cp-zion/img/webpusharrow_12291d.svg";